/**
 * @generated SignedSource<<c84b691ed3042b7839abfb9f50854ffe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventFiltersTotalCountFragment$data = {
  readonly eventCount: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "EventFiltersTotalCountFragment";
};
export type EventFiltersTotalCountFragment$key = {
  readonly " $data"?: EventFiltersTotalCountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventFiltersTotalCountFragment">;
};

import EventFiltersTotalCountFragmentPaginationQuery_graphql from './EventFiltersTotalCountFragmentPaginationQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": EventFiltersTotalCountFragmentPaginationQuery_graphql
    }
  },
  "name": "EventFiltersTotalCountFragment",
  "selections": [
    {
      "alias": "eventCount",
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b064528b125aba506ab6db236b4705a4";

export default node;
